<template>
    <div class="text-center">
        <vue-circle
            :progress="currentProgress"
            :size="200"
            :reverse="false"
            line-cap="round"
            empty-fill="rgba(0, 0, 0, .1)"
            insert-mode="append"
            :thickness="15"
            :show-percent="true"
            :fill="fill">
            <p style="padding-top: 15px;">{{ text }}</p>
        </vue-circle>
        <p>
            {{ current }}/{{ max }}
        </p>
    </div>
</template>

<script>
    import VueCircle from 'vue2-circle-progress'
    export default {
        
        components: {
            VueCircle
        },

        props: {
            color: {
                type: String,
                required: false
            },
            current: {
                type: Number,
                required: true
            },
            max: {
                type: Number,
                required: true
            },
            text: {
                type: String,
                required: true
            },
        },

        data(){
            return {
                fill : { color: this.color },
            }
        },

        computed: {
            currentProgress: function() {
                if(this.current == 0 || this.max == 0) {
                    return 0;
                }

                return (this.current/this.max) * 100;
            }
        }
    }
</script>
